export const usoDeCFDIMap: {
	[index: string]: {
		label: string
	}
} = {
	G01: { label: 'Adquisición de mercancías' },
	G02: { label: 'Devoluciones, descuentos o bonificaciones' },
	G03: { label: 'Gastos en general' },
	I01: { label: 'Construcciones' },
	I02: { label: 'Mobiliario y equipo de oficina por construcciones' },
	I03: { label: 'Equipo de transporte' },
	I04: { label: 'Equipo de cómputo y accesorios' },
	I05: { label: 'Dados, troqueles, moldes, matrices y herramientas' },
	I06: { label: 'Comunicaciones telefónicas' },
	I07: { label: 'Comunicaciones Satelitales' },
	I08: { label: 'Otras máquinas y equipo' },
	S01: { label: 'Sin efectos fiscales' },
}
